
export const handleUpload = async (Data, LogUserType, LocationCode, menuCode) => {
    const formData = new FormData();
    formData.append('excelFile1', Data.excelFile1);
    formData.append('excelFile2', Data.excelFile2);
    formData.append('selectedTxn', Data.selectedTxn);
    formData.append('selectedLocation', Data.selectedLocation);
    formData.append('refDocNumber', Data.refDocNumber);
    formData.append('remark1', Data.remark1);
    formData.append('logUser', LogUserType);
    formData.append('logLocation', LocationCode);
    formData.append('menuCode', menuCode);

    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    try {
        const response = await fetch(`${ApiURL}ExcelUpload/CustomFreeze`, {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        });

        if (response.ok) {
            const data = await response.json();

            if (data.success == true) {
                return { success: true, msg: data.msg };
            } else {
                return { success: false, msg: data.msg };
            }
        } else {
            return { success: false, msg: "Something went wrong!" };
        }
    } catch (error) {
        console.error('Error uploading file:', error);
        return { success: false, msg: 'Error uploading file' };
    }
};
